import React, { useMemo } from 'react';
import Progress from 'antd/es/progress';
import cx from 'clsx';
import style from './index.module.scss';

export const ContentLengthProgress = ({
  currentLength = 0,
  maxLimit = 2000,
}: {
  currentLength: number;
  maxLimit: number;
}) => {
  const leftLength = useMemo(() => maxLimit - currentLength, [maxLimit, currentLength]);
  const percentOnProgress = useMemo(() => {
    return (currentLength / maxLimit) * 100;
  }, [currentLength, maxLimit]);
  return (
    <div className={style.contentLengthProgress}>
      {leftLength <= -100 ? (
        <div className={style.limitExceeded}>{leftLength}</div>
      ) : leftLength < 100 ? (
        // todo
        // @ts-ignore
        <Progress
          type="circle"
          className={cx(leftLength < 0 && style.limitExceededProcess)}
          strokeColor={leftLength < 0 ? 'var(--color-red)' : 'var(--color-primary)'}
          percent={percentOnProgress}
          format={() => leftLength}
        />
      ) : null}
    </div>
  );
};
